import Analytics from 'analytics';
import googleTagManager from '@analytics/google-tag-manager';
import googleAnalytics from '@analytics/google-analytics';

// import rudderAnalytics from './rudderAnalyticsPlugin';

export function initAnalytics() {
  const { hostname } = window.location;
  const isProductionWebsite = hostname === 'hire.upraised.co';
  const isStagingWebsite = hostname.endsWith('hire.staging.upraised.co');

  let gtmContainerId;
  let gaTrackingId;
  // let rudderAnalyticsWriteKey;
  // let rudderAnalyticsDataPlaneUrl;
  let debug = false;

  if (isProductionWebsite) {
    gtmContainerId = 'GTM-KKSP5WZ';
    gaTrackingId = 'UA-149869976-1';
    // rudderAnalyticsWriteKey = '1wIUViPqWApcqwrmIeYN551slfV';
    // rudderAnalyticsDataPlaneUrl = 'https://rudder.upraised.co';
  } else if (isStagingWebsite) {
    gtmContainerId = 'GTM-W6MHLBB';
    gaTrackingId = 'UA-149869976-2';
    // rudderAnalyticsWriteKey = '1wXZKYOJqJdyYJhXrW26aDmLWGu';
    // rudderAnalyticsDataPlaneUrl = 'https://rudder.staging.upraised.co';
    debug = true;
  } else {
    gtmContainerId = 'GTM-NHGKV9M';
    gaTrackingId = 'UA-149869976-3';
    // rudderAnalyticsWriteKey = 'ABCD';
    // rudderAnalyticsDataPlaneUrl = 'http://rudder.upraised.localhost:8080';
    debug = true;
  }

  const gtmInstance = googleTagManager({
    containerId: gtmContainerId,
  });
  // Patch `page` method to explicitly provide event name for page views
  const origGtmInstancePageMethod = gtmInstance.page;
  gtmInstance.page = (data) => {
    if (data?.payload?.properties && !data?.payload?.properties?.event) {
      data.payload.properties.event = 'pageview';
    }
    origGtmInstancePageMethod(data);
  };

  const analytics = Analytics({
    app: 'hire-web',
    debug,
    plugins: [
      gtmInstance,
      googleAnalytics({
        trackingId: gaTrackingId,
      }),
      // rudderAnalytics({
      //   writeKey: rudderAnalyticsWriteKey,
      //   dataPlaneUrl: rudderAnalyticsDataPlaneUrl,
      // }),
    ],
  });

  return analytics;
}
